<p-sidebar
  [(visible)]="visible"
  position="right"
  [style]="{ width: '54rem' }"
  [modal]="true"
  styleClass="bookmark-validation-panel">
  <ng-template pTemplate="header">
    <app-header
      styleClass="text-2xl m-0"
      icon="fas fa-file-circle-check"
      text="Ansichten prüfen"></app-header>
  </ng-template>

  <div class="validation-content">
    <!-- Tab View -->
    <p-tabView>
      <!-- Tab 1: Public Bookmarks Validation -->
      <p-tabPanel>
        <ng-template pTemplate="header">
          <div class="flex align-items-center gap-2 max-h-1rem">
            <i class="fas fa-earth-europe"></i>
            <span>Öffentliche Ansichten</span>
            <p-badge
              *ngIf="invalidBookmarks().length > 0"
              [value]="invalidBookmarks().length + ''"
              severity="danger"
              styleClass="ml-2" />
          </div>
        </ng-template>

        <!-- Summary Section for Public -->
        <div class="summary-section mb-4">
          <h3 class="m-0 mb-3">Zusammenfassung</h3>

          <div class="grid" *ngIf="validationSummary()">
            <div class="col-12 md:col-6 lg:col-3">
              <div class="surface-card p-3 border-round">
                <div class="flex align-items-center gap-3">
                  <div
                    class="flex align-items-center justify-content-center bg-blue-100 border-round"
                    style="width: 3rem; height: 3rem">
                    <i class="fas fa-bookmark text-blue-500 text-xl"></i>
                  </div>
                  <div>
                    <span class="block text-500 font-medium mb-1">Gesamt</span>
                    <div class="text-900 font-bold text-xl">
                      {{ validationSummary()?.totalBookmarks || 0 }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 md:col-6 lg:col-3">
              <div class="surface-card p-3 border-round">
                <div class="flex align-items-center gap-3">
                  <div
                    class="flex align-items-center justify-content-center bg-green-100 border-round"
                    style="width: 3rem; height: 3rem">
                    <i class="fas fa-check text-green-500 text-xl"></i>
                  </div>
                  <div>
                    <span class="block text-500 font-medium mb-1">Gültig</span>
                    <div class="text-900 font-bold text-xl">
                      {{ validationSummary()?.validBookmarks || 0 }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 md:col-6 lg:col-3">
              <div class="surface-card p-3 border-round">
                <div class="flex align-items-center gap-3">
                  <div
                    class="flex align-items-center justify-content-center bg-red-100 border-round"
                    style="width: 3rem; height: 3rem">
                    <i
                      class="fas fa-exclamation-triangle text-red-500 text-xl"></i>
                  </div>
                  <div>
                    <span class="block text-500 font-medium mb-1"
                      >Fehlerhaft</span
                    >
                    <div class="text-900 font-bold text-xl">
                      {{ validationSummary()?.invalidBookmarks || 0 }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 md:col-6 lg:col-3">
              <div class="surface-card p-3 border-round">
                <div class="flex align-items-center gap-3">
                  <div
                    class="flex align-items-center justify-content-center bg-orange-100 border-round"
                    style="width: 3rem; height: 3rem">
                    <i class="fas fa-list text-orange-500 text-xl"></i>
                  </div>
                  <div>
                    <span class="block text-500 font-medium mb-1"
                      >Probleme</span
                    >
                    <div class="text-900 font-bold text-xl">
                      {{ validationSummary()?.totalIssues || 0 }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <p-message
            *ngIf="validationSummary()?.invalidBookmarks === 0"
            severity="success"
            text="Alle öffentlichen Ansichten sind korrekt konfiguriert!"
            styleClass="w-full mt-3" />
        </div>

        <p-divider />

        <!-- Issues Section -->
        <div class="issues-section" *ngIf="invalidBookmarks().length > 0">
          <app-header
            icon="fas fa-exclamation-circle"
            [count]="invalidBookmarks().length"
            text="Fehlerhafte öffentliche Ansichten"></app-header>

          <p-accordion [multiple]="true">
            <p-accordionTab *ngFor="let result of invalidBookmarks()">
              <ng-template pTemplate="header">
                <div
                  class="flex align-items-center justify-content-between w-full">
                  <div class="flex align-items-center gap-2">
                    <i class="fas fa-bookmark"></i>
                    <span class="font-semibold">{{
                      result.bookmarkTitle
                    }}</span>
                  </div>
                  <div class="flex align-items-center gap-2">
                    <p-button
                      icon="fas fa-external-link-alt"
                      [text]="true"
                      [rounded]="true"
                      size="small"
                      severity="secondary"
                      pTooltip="Ansicht in öffentlicher Ansicht öffnen"
                      tooltipPosition="top"
                      (onClick)="
                        openBookmarkInPublicView(result.bookmarkId);
                        $event.stopPropagation()
                      " />
                    <p-button
                      icon="fas fa-link"
                      [text]="true"
                      [rounded]="true"
                      size="small"
                      severity="secondary"
                      pTooltip="Link kopieren"
                      tooltipPosition="top"
                      (onClick)="
                        copyBookmarkLink(result.bookmarkId);
                        $event.stopPropagation()
                      " />
                    <p-tag
                      [value]="
                        result.issues.length > 0
                          ? result.issues.length + ' Probleme'
                          : '1 Problem'
                      "
                      severity="danger" />
                  </div>
                </div>
              </ng-template>

              <div class="bookmark-issues">
                <div
                  class="flex justify-content-between align-items-center mb-3">
                  <p class="text-sm text-500">
                    Diese Ansicht enthält
                    <b>{{ result.issues.length }}</b> Problem(e), die in
                    öffentlichen Dashboards zu fehlenden Daten führen können.
                  </p>
                  <p-button
                    [rounded]="true"
                    icon="fas fa-wand-magic-sparkles"
                    label="Alle beheben"
                    styleClass="min-w-max"
                    size="small"
                    [outlined]="true"
                    (onClick)="fixAllIssuesInBookmark(result, $event)" />
                </div>

                <div class="issue-list">
                  <!-- Grouped Issues Display -->
                  @for (
                    group of groupIssues(result.issues);
                    track group.groupKey
                  ) {
                    <div class="issue-group mb-3">
                      <!-- Group Header -->
                      <div
                        class="group-header surface-100 p-3 border-round-top"
                        [ngClass]="{
                          'border-round':
                            group.issues.length === 1 &&
                            !group.issues[0].widgetHeadline,
                        }">
                        <div class="flex align-items-start gap-3">
                          <div
                            class="flex-shrink-0 flex align-items-center justify-content-center border-round"
                            [ngClass]="{
                              'bg-red-100':
                                getIssueSeverityClass(group.issues[0]) ===
                                'danger',
                              'bg-orange-100':
                                getIssueSeverityClass(group.issues[0]) ===
                                'warning',
                              'bg-blue-100':
                                getIssueSeverityClass(group.issues[0]) ===
                                'info',
                            }"
                            style="width: 2.5rem; height: 2.5rem">
                            <i
                              [class]="getIssueIcon(group.issues[0])"
                              [ngClass]="{
                                'text-red-500':
                                  getIssueSeverityClass(group.issues[0]) ===
                                  'danger',
                                'text-orange-500':
                                  getIssueSeverityClass(group.issues[0]) ===
                                  'warning',
                                'text-blue-500':
                                  getIssueSeverityClass(group.issues[0]) ===
                                  'info',
                              }"></i>
                          </div>

                          <div class="flex-grow-1">
                            <div class="font-semibold mb-1">
                              {{ group.message }}
                            </div>

                            <div
                              class="text-sm text-500 mt-2 flex gap-3 text-color-secondary">
                              <div *ngIf="group.details.dataLayerName">
                                <i
                                  class="fas fa-calendar w-1rem mr-1 text-center"></i>
                                <b>Jahr:</b> {{ group.details.dataLayerName }}
                              </div>
                              <div *ngIf="group.details.indicatorName">
                                <i
                                  class="fas fa-ruler-vertical w-1rem mr-1 text-center"></i>
                                <b>Indikator:</b>
                                {{ group.details.indicatorName }}
                              </div>
                            </div>
                          </div>

                          <div class="flex-shrink-0">
                            <p-button
                              *ngIf="
                                group.issueType === 'unpublished-datalayer' ||
                                group.issueType === 'unpublished-data'
                              "
                              icon="fas fa-check"
                              [text]="true"
                              [raised]="true"
                              [rounded]="true"
                              severity="success"
                              pTooltip="Problem beheben (für alle {{
                                group.issues.length
                              }} Widget(s))"
                              tooltipPosition="left"
                              (click)="fixGroupedIssue(group, $event)" />
                            @if (
                              group.issueType === 'missing-datalayer' ||
                              group.issueType === 'missing-indicator'
                            ) {
                              <p-button
                                icon="fas fa-eraser"
                                [text]="true"
                                [raised]="true"
                                [rounded]="true"
                                severity="warning"
                                [pTooltip]="
                                  'Referenz entfernen (aus allen ' +
                                  group.issues.length +
                                  ' Widget(s))'
                                "
                                tooltipPosition="left"
                                (click)="fixGroupedIssue(group, $event)" />
                            }

                            <p-button
                              *ngIf="
                                group.issueType === 'unpublished-indicator'
                              "
                              icon="fas fa-info-circle"
                              [text]="true"
                              [rounded]="true"
                              severity="secondary"
                              pTooltip="Nicht automatisch behebbar"
                              tooltipPosition="left"
                              (click)="fixGroupedIssue(group, $event)" />
                          </div>
                        </div>
                      </div>

                      <!-- Widget List (if multiple widgets or widget has headline) -->
                      <div
                        *ngIf="
                          group.issues.length > 1 ||
                          (group.issues.length === 1 &&
                            group.issues[0].widgetHeadline)
                        "
                        class="widget-list surface-50 border-round-bottom p-2 border-top-1 surface-border">
                        <!-- Widget count badge if multiple widgets -->
                        <div class="mb-2 ml-3 flex align-items-center">
                          <div class="text-color-secondary text-sm">
                            <i class="fas fa-info-circle mr-2"></i> Gefunden
                            in...
                          </div>
                          <p-tag
                            [value]="
                              group.issues.length +
                              ' Darstellung' +
                              (group.issues.length > 1 ? 'en' : '') +
                              ' betroffen'
                            "
                            severity="secondary"
                            class="ml-auto" />
                        </div>
                        <div class="ml-3 flex flex-column gap-2">
                          <div
                            class="flex align-items-center gap-3"
                            *ngFor="let issue of group.issues">
                            <i
                              [class]="getWidgetTypeIcon(issue.widgetType)"
                              class="text-sm text-500"></i>
                            <span class="text-sm text-color-secondary"
                              >{{
                                issue.widgetHeadline || 'Unbenanntes Widget'
                              }}
                            </span>
                            <code class="flex align-items-center gap-1 py-1"
                              ><i class="fas fa-key"></i>
                              {{ issue.widgetId }}</code
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </p-accordionTab>
          </p-accordion>
        </div>

        <!-- Empty State -->
        <div
          class="empty-state text-center p-5"
          *ngIf="validationSummary() && invalidBookmarks().length === 0">
          <i class="fas fa-check-circle text-6xl text-green-500 mb-3"></i>
          <h3>Alle Ansichten sind korrekt konfiguriert!</h3>
          <p class="text-500">
            Es wurden keine Probleme mit öffentlichen Ansichten gefunden.
          </p>
        </div>
      </p-tabPanel>

      <!-- Tab 2: Access Issues -->
      <p-tabPanel>
        <ng-template pTemplate="header">
          <div class="flex align-items-center gap-2 max-h-1rem">
            <i class="fas fa-lock"></i>
            <span>Zugriffsprobleme</span>
            <p-badge
              *ngIf="invalidAccessBookmarks().length > 0"
              [value]="invalidAccessBookmarks().length + ''"
              severity="warning"
              styleClass="ml-2" />
          </div>
        </ng-template>

        <!-- Summary Section for Access -->
        <div class="summary-section mb-4">
          <h3 class="m-0 mb-3">Zusammenfassung</h3>

          <div class="grid" *ngIf="validationSummary()?.accessValidation">
            <div class="col-12 md:col-6 lg:col-4">
              <div class="surface-card p-3 border-round">
                <div class="flex align-items-center gap-3">
                  <div
                    class="flex align-items-center justify-content-center bg-blue-100 border-round"
                    style="width: 3rem; height: 3rem">
                    <i class="fas fa-bookmark text-blue-500 text-xl"></i>
                  </div>
                  <div>
                    <span class="block text-500 font-medium mb-1">Gesamt</span>
                    <div class="text-900 font-bold text-xl">
                      {{
                        validationSummary()?.accessValidation?.totalBookmarks ||
                          0
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <div class="surface-card p-3 border-round">
                <div class="flex align-items-center gap-3">
                  <div
                    class="flex align-items-center justify-content-center bg-orange-100 border-round"
                    style="width: 3rem; height: 3rem">
                    <i
                      class="fas fa-exclamation-triangle text-orange-500 text-xl"></i>
                  </div>
                  <div>
                    <span class="block text-500 font-medium mb-1"
                      >Eingeschränkt</span
                    >
                    <div class="text-900 font-bold text-xl">
                      {{
                        validationSummary()?.accessValidation
                          ?.invalidBookmarks || 0
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <div class="surface-card p-3 border-round">
                <div class="flex align-items-center gap-3">
                  <div
                    class="flex align-items-center justify-content-center bg-orange-100 border-round"
                    style="width: 3rem; height: 3rem">
                    <i class="fas fa-list text-orange-500 text-xl"></i>
                  </div>
                  <div>
                    <span class="block text-500 font-medium mb-1"
                      >Probleme</span
                    >
                    <div class="text-900 font-bold text-xl">
                      {{
                        validationSummary()?.accessValidation?.totalIssues || 0
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <p-message
            *ngIf="
              validationSummary()?.accessValidation?.invalidBookmarks === 0
            "
            severity="success"
            text="Sie haben Zugriff auf alle Daten in diesen Ansichten!"
            styleClass="w-full mt-3" />
        </div>

        <p-divider />

        <!-- Info Message -->
        <app-alert
          severity="info"
          styleClass="w-full mb-4 p-3"
          [canToggle]="false"
          *ngIf="invalidAccessBookmarks().length > 0">
          <div>
            <i class="fas fa-info-circle mr-2"></i>
            <strong>Hinweis:</strong> Diese Probleme können nicht automatisch
            behoben werden. Sie benötigen Zugriff auf zusätzliche
            Arbeitsbereiche.
          </div>
        </app-alert>

        <!-- Access Issues Section -->
        <div class="issues-section" *ngIf="invalidAccessBookmarks().length > 0">
          <app-header
            icon="fas fa-lock"
            [count]="invalidAccessBookmarks().length"
            text="Ansichten mit Zugriffsproblemen"></app-header>

          <p-accordion [multiple]="true">
            <p-accordionTab *ngFor="let result of invalidAccessBookmarks()">
              <ng-template pTemplate="header">
                <div
                  class="flex align-items-center justify-content-between w-full">
                  <div class="flex align-items-center gap-2">
                    <i class="fas fa-bookmark"></i>
                    <span class="font-semibold">{{
                      result.bookmarkTitle
                    }}</span>
                  </div>
                  <div class="flex align-items-center gap-2">
                    <p-button
                      icon="fas fa-external-link-alt"
                      [text]="true"
                      [rounded]="true"
                      size="small"
                      severity="secondary"
                      pTooltip="Ansicht öffnen"
                      tooltipPosition="top"
                      (onClick)="
                        openBookmarkInPublicView(result.bookmarkId);
                        $event.stopPropagation()
                      " />
                    <p-tag
                      [value]="result.issues.length + ' Problem(e)'"
                      severity="warning" />
                  </div>
                </div>
              </ng-template>

              <div class="bookmark-issues">
                <p class="text-sm text-500 mb-3">
                  Diese Ansicht enthält
                  <b>{{ result.issues.length }}</b> Zugriffseinschränkung(en).
                  Die betroffenen Widgets werden für Sie nicht korrekt
                  angezeigt.
                </p>

                <div class="issue-list">
                  <!-- Grouped Issues Display -->
                  @for (
                    group of groupIssues(result.issues);
                    track group.groupKey
                  ) {
                    <div class="issue-group mb-3">
                      <!-- Group Header -->
                      <div
                        class="group-header surface-100 p-3 border-round-top"
                        [ngClass]="{
                          'border-round':
                            group.issues.length === 1 &&
                            !group.issues[0].widgetHeadline,
                        }">
                        <div class="flex align-items-start gap-3">
                          <div
                            class="flex-shrink-0 flex align-items-center justify-content-center border-round bg-orange-100"
                            style="width: 2.5rem; height: 2.5rem">
                            <i
                              [class]="getIssueIcon(group.issues[0])"
                              class="text-orange-500"></i>
                          </div>

                          <div class="flex-grow-1">
                            <div class="font-semibold mb-1">
                              {{ group.message }}
                            </div>

                            <div
                              class="text-sm text-500 mt-2 flex gap-3 text-color-secondary">
                              <div *ngIf="group.details.dataLayerName">
                                <i
                                  class="fas fa-calendar w-1rem mr-1 text-center"></i>
                                <b>Jahr:</b> {{ group.details.dataLayerName }}
                              </div>
                              <div *ngIf="group.details.indicatorName">
                                <i
                                  class="fas fa-ruler-vertical w-1rem mr-1 text-center"></i>
                                <b>Indikator:</b>
                                {{ group.details.indicatorName }}
                              </div>
                            </div>

                            <!-- Widget count badge if multiple widgets -->
                            <p-tag
                              *ngIf="group.issues.length > 1"
                              [value]="
                                group.issues.length +
                                ' Widget' +
                                (group.issues.length > 1 ? 's' : '') +
                                ' betroffen'
                              "
                              severity="secondary"
                              styleClass="mt-2" />

                            <!-- Action Suggestion -->
                            <div
                              class="mt-3 p-2 surface-50 border-round border-left-3 border-orange-500">
                              <div class="flex align-items-start gap-2">
                                <i
                                  class="fas fa-lightbulb text-orange-500 mt-1"></i>
                                <div class="text-sm text-600">
                                  <strong>Lösungsvorschlag:</strong>
                                  {{ getAccessIssueSuggestion(group) }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Widget List (if multiple widgets or widget has headline) -->
                      <div
                        *ngIf="
                          group.issues.length > 1 ||
                          (group.issues.length === 1 &&
                            group.issues[0].widgetHeadline)
                        "
                        class="widget-list surface-50 border-round-bottom p-2 border-top-1 surface-border">
                        <div class="text-xs text-500 mb-2 px-2 pt-1">
                          <i class="fas fa-layer-group mr-1"></i>
                          Betroffene Widgets:
                        </div>
                        <div
                          *ngFor="let issue of group.issues; let last = last"
                          class="widget-item px-2 py-1 flex align-items-center gap-2"
                          [ngClass]="{ 'mb-1': !last }">
                          <i
                            [class]="getWidgetTypeIcon(issue.widgetType)"
                            class="text-sm text-500"></i>
                          <span class="text-sm text-color-secondary">{{
                            issue.widgetHeadline || 'Unbenanntes Widget'
                          }}</span>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </p-accordionTab>
          </p-accordion>
        </div>

        <!-- Empty State for Access -->
        <div
          class="empty-state text-center p-5"
          *ngIf="
            validationSummary()?.accessValidation &&
            invalidAccessBookmarks().length === 0
          ">
          <i class="fas fa-check-circle text-6xl text-green-500 mb-3"></i>
          <h3>Vollständiger Zugriff!</h3>
          <p class="text-500">
            Sie haben Zugriff auf alle Daten in allen Ansichten.
          </p>
        </div>
      </p-tabPanel>
    </p-tabView>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex gap-3 align-items-center">
      <small class="text-500" *ngIf="validationSummary()">
        Zuletzt validiert:
        {{
          validationSummary()?.validatedAt
            | date: 'dd.MM.yyyy HH:mm:ss' : '' : 'de'
        }}
      </small>

      <p-button
        [rounded]="true"
        class="ml-auto"
        icon="fas fa-refresh"
        label="Neu validieren"
        [text]="true"
        (onClick)="runValidation()" />
      <p-button
        icon="fas fa-xmark"
        [outlined]="true"
        [rounded]="true"
        severity="secondary"
        label="Schließen"
        (onClick)="close()" />
    </div>
  </ng-template>
</p-sidebar>
<app-mask [visible]="visible" (click)="visible = false"></app-mask>
